export const CODIGOS_SEGURO_PLANILLA = [
  {
    codigo: '0803',
    descripcion: 'PÓLIZA DE SEGURO - D. LEG. 688',
    descripcionCorta: 'Póliza D.L. 688',
  },
  {
    codigo: '0805',
    descripcion: 'PENSIONES – SEGURO COMPLEMENTARIO DE TRABAJO DE RIESGO',
    descripcionCorta: 'Pensiones SCTR',
  },
  {
    codigo: '0806',
    descripcion: 'ESSALUD – SEGURO COMPLEMENTARIO DE TRABAJO DE RIESGO',
    descripcionCorta: 'EsSalud SCTR',
  },
  {
    codigo: '0810',
    descripcion: 'EPS - SEGURO COMPLEMENTARIO DE TRABAJO DE RIESGO',
    descripcionCorta: 'EPS SCTR',
  },
];

export const buscarSeguroPlanillaPorCodigo = (codigo) =>
  CODIGOS_SEGURO_PLANILLA.find((item) => item.codigo === codigo) || null;
